import React, { Fragment } from 'react';
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../actions/dCandidate";
import anime from 'animejs';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

const SadhanaSummary = (props) => {
    return (
        <Fragment>
            {/* <section className="page-title-big-typography bg-dark-gray ipad-top-space-margin xs-py-0 cover-background background-position-center-top" style={{ backgroundImage: "url(assets/images/others/about_us.jpeg)" }}>
                <div className="opacity-extra-medium bg-gradient-black-green"></div>
                <div className="container">
                    <div className="row align-items-center justify-content-center small-screen">
                        <div className="col-lg-8 col-md-12 text-center">
                            <h1 className="alt-font text-white font-weight-600 mb-0">Sadhana Summary</h1>
                        </div>
                    </div>
                </div>
            </section> */}
            <br /><br /><br /><br />
            <img src="assets/images/sadhana/sadhana_summary.jpeg" alt="Sadhana Summary" style={{width: '100%'}} />
        </Fragment>            
    )
}

const mapStateToProps = (state) => {
    return { data: state.dCandidate.list };
};

const mapActionToProps = {
    fetchData: actions.fetchallProperty
}

export default connect(mapStateToProps, mapActionToProps)(SadhanaSummary);